import React from 'react';
import { Accordion } from 'react-bootstrap';
import CardRenderer from '../CardRenderer';

interface Card {
  title?: string;
  blocks?: any[];
  card_id?: string;
  collapse_settings?: {
    open?: boolean;
    title?: string;
  };
  block_layout?: string;
  [key: string]: any; // For other card properties
}

interface AccordionContent {
  title?: string;
  open?: boolean;
  cards?: Card[];
}

interface AccordionBlockProps {
  block: {
    content?: AccordionContent;
  };
}

const AccordionBlock: React.FC<AccordionBlockProps> = ({ block }) => {
  if (!block.content) return null;

  return (
    <Accordion defaultActiveKey={block.content.open ? '0' : undefined}>
      <Accordion.Item eventKey="0">
        <Accordion.Header>{block.content.title}</Accordion.Header>
        <Accordion.Body>
          {block.content.cards &&
            block.content.cards.map((card, index) => (
              <CardRenderer key={index} card={card} />
            ))}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default AccordionBlock;
